import type { KeyOfNumberValues } from '~/helpers/utility-types'

export type AppEnvironment = 'local' | 'dev1' | 'dev2' | 'dev3' | 'dev4' | 'staging' | 'production'

export function getClientEnvironment(): AppEnvironment {
  return ((window as any).ENV?.ENV_NAME as AppEnvironment) || 'local'
}

export function getServerEnvironment(): AppEnvironment {
  return (process.env.ENV_NAME as AppEnvironment) || 'local'
}

export interface EnvironmentOptions {
  DATADOG_APPLICATION_ID: string
  DATADOG_CLIENT_TOKEN: string
  DATADOG_SESSION_SAMPLE_RATE: number
  DATADOG_SESSION_REPLAY_SAMPLE_RATE: number
  DATADOG_TRACE_SAMPLE_RATE: number
  DATADOG_TELEMETRY_CONFIGURATION_SAMPLE_RATE: number
  DATADOG_TELEMETRY_USAGE_SAMPLE_RATE: number
  DATADOG_TELEMETRY_SAMPLE_RATE: number
  // need to extend EnvironmentOptions with all the env variables
}

export function getEnvVar<K extends keyof EnvironmentOptions>(name: K): string | undefined {
  const value = process.env[name]

  if (!value) {
    return undefined
  }

  return value
}

export function getEnvVarNumber<K extends KeyOfNumberValues<EnvironmentOptions>>(
  name: K,
  defaultValue: number,
): number {
  const value = getEnvVar<K>(name)

  if (!value) {
    return defaultValue
  }

  const number = parseInt(value)

  if (isNaN(number)) {
    return defaultValue
  }

  return number
}
